import { render, staticRenderFns } from "./SentenceContainer.vue?vue&type=template&id=750bc0d0&scoped=true"
import script from "./SentenceContainer.vue?vue&type=script&lang=js"
export * from "./SentenceContainer.vue?vue&type=script&lang=js"
import style0 from "./SentenceContainer.vue?vue&type=style&index=0&id=750bc0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750bc0d0",
  null
  
)

export default component.exports